import { render } from "./Help.vue?vue&type=template&id=4f9a4de2"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=4f9a4de2&lang=css"
script.render = render

export default script